import _ from 'lodash';
import axios from 'axios';
// import getTime from 'date-fns/get_time'

// import store from '@/store'

const AUTH_ENDPOINT = `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_AUTH_ROUTE}`;
const PASSWORD_ENDPOINT = `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PASSWORD_ROUTE}`;

export default {
    setToken(token, name = 'token') {
        localStorage.setItem(name, token);
    },
    getToken(name = 'token') {
        return localStorage.getItem(name) || '';
    },
    removeToken: (name = 'token') =>
        new Promise((resolve, reject) => {
            // TODO
            // invalidate token server side

            localStorage.removeItem(name);
            setTimeout(() => resolve(), 150);
        }),
    // getHeader () {
    //     const token = localStorage.getItem('token')
    //     return { headers: {'Authorization': `Bearer ${token}`} }
    // },
    // checkToken () {
    //     /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    //     return new Promise((resolve, reject) => {
    //         const timestamp = getTime(new Date())

    //         if (store.state.auth.token && timestamp < store.state.auth.jwt.exp * 1000) {
    //             resolve(true)
    //         } else if (store.state.auth.token) {
    //             axios.post(`${AUTH_ENDPOINT}check`, {}, this.getHeader())
    //                 .then(result => {
    //                     if (_.get(result, 'data.auth') === true) resolve(result)
    //                     else reject('unexpected response for the check auth request')
    //                 })
    //                 .catch(err => reject(err))
    //         } else {
    //             reject('no token provided')
    //         }
    //         // if (store.state.setup.auth.id) {
    //         //     resolve(true)
    //         // }else{
    //         //     resolve(false)
    //         // }
    //         // resolve(true)
    //     })
    // },
    refreshToken (name = 'token') {
        /*eslint no-unused-vars: ["error", { "args": "none" }]*/
        // console.log('>>', 'api auth', 'refreshToken', name)
        return new Promise((resolve, reject) => {
            const token = this.getToken(name);
            // console.log('>>', 'api auth', 'expired token', token)
            if (token) {
                const config = {
                    headers: { Authorization: `Bearer ${token}` }
                };

                axios.post(`${AUTH_ENDPOINT}refresh`, {}, config)
                    .then(result => {
                        if (result.error) {
                            return reject(result.error);
                        }
                        if (result.data && result.data.token) {
                            return resolve(result.data.token);
                        }
                        if (result.headers && result.headers.authorization) {
                            const jwt = result.headers.authorization.split('Bearer');
                            if (jwt.length) {
                                const token = _.compact(jwt)[0].trim();
                                return resolve(token);
                            }
                        }
                        reject(new Error('No token in refresh response'));
                    })
                    .catch(error => {
                        // console.log('>>', 'api auth', 'refreshToken', 'axios error', error)
                        reject(error)
                    })
            } else {
                reject()
            }
        })
    },
    login(user) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${AUTH_ENDPOINT}login`, user)
                .then(result => resolve(result))
                .catch(err => reject(err));
        });
    },
    // Enter an admin's account. The answer is the session token; it replaces
    // the one token this browser holds. The server records the session and
    // remembers who really entered - nothing about that is kept here.
    loginAs(id) {
        return new Promise((resolve, reject) => {
            const config = {
                headers: { Authorization: `Bearer ${this.getToken()}` }
            };
            axios
                .post(`${AUTH_ENDPOINT}login-as`, { id }, config)
                .then(result => resolve(result))
                .catch(err => reject(err));
        });
    },
    // Leave the account. Travels on the SESSION token (the only one there is)
    // and answers with a token for our own account, minted by the server from
    // its record of who entered. Signing out stops being a way this can end.
    stopLoginAs() {
        return new Promise((resolve, reject) => {
            const config = {
                headers: { Authorization: `Bearer ${this.getToken()}` }
            };
            axios
                .post(`${AUTH_ENDPOINT}stop-login-as`, {}, config)
                .then(result => resolve(result))
                .catch(err => reject(err));
        });
    },
    forgotPassword(payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${PASSWORD_ENDPOINT}email`, payload)
                .then(result => resolve(result))
                .catch(error => reject(error));
        });
    },
    resetPassword(payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${PASSWORD_ENDPOINT}reset`, payload)
                .then(result => {
                    if (_.get(result, 'data.success')) resolve(result);
                    else reject('something went wrong');
                })
                .catch(error => reject(error));
        });
    }
};
